/* Keep Escape available when legacy theme or preview listeners cancel its default action. */
document.addEventListener('keydown', function (event) {
  if (event.key !== 'Escape') return;
  var menu = document.querySelector('#dotson-site-menu:popover-open');
  if (menu) menu.hidePopover();
}, true);
